<template>
  <div class="send-mail">
    <iframe class="iframe-send-mail" :src="link"></iframe>
  </div>
</template>

<script>


export default {
  components: {
  },
  directives: {
  },
  data() {
    return {
      link :window.process.env.LinkFoSendGrid + this.$route.params.id+"?v="+Math.random()
    };
  },
  methods: {
  },
  computed: {
  },
  mounted() {
  },
};
</script>

<style lang="scss" scoped>
  .iframe-send-mail {
    position: absolute;
    margin: 0px;
    height: 100vh;
    width: 100vw;
    border: 0;
  }
</style>



// WEBPACK FOOTER //
// src/components/components/SendMail.vue